import { Col, Row } from "reactstrap"

import { AvField } from "availity-reactstrap-validation"
import BaselForm from "../Common/BaselForm"
import RotterdamForm from "../Common/RotterdamForm"
import { useEffect, useState } from "react"
import General from "services/GeneralEndpoints"

const user = JSON.parse(localStorage.getItem("authUser"))
let generalService = new General(user)

const ApplicationDetails = props => {
  const [appConvention, setappConvention] = useState(<div></div>)
  const [baselOrRotterdam, setbaselOrRotterdam] = useState("")
  const [appType, setappType] = useState()


  const [companies, setcompanies] = useState()
  const [companyId, setcompanyId] = useState()

  const [editConvention, seteditConvention] = useState()

  const toggleBaselOrRotterdam = value => {
    //console.log(value)
    setbaselOrRotterdam(value)
  }

  const toggleAppType = value => {
    //console.log(value)
    setappType(value)
  }

  useEffect(() => {
    if (props.editMode) {
      if (props.appDetails.basel_convention) {
        setappConvention(
          <BaselForm editMode={props.editMode} appDetails={props.appDetails} />
        )
        seteditConvention("basel")
        // set application type (company/individual)
        if (props.appDetails.basel_convention.company_id != null) {
          setappType("company")
          setcompanyId(props.appDetails.basel_convention.company_id)
        } else {
          setappType("individual")
        }
      } else if (props.appDetails.rotterdam_convention) {
        setappConvention(
          <RotterdamForm
            editMode={props.editMode}
            appDetails={props.appDetails}
          />
        )
        seteditConvention("rotterdam")
        // set application type (company/individual)
        if (props.appDetails.rotterdam_convention.company_id != null) {
          setappType("company")
          setcompanyId(props.appDetails.rotterdam_convention.company_id)
        } else {
          setappType("individual")
        }
      }
    }
    fetchCompanies()
  }, [props.appDetails])

  useEffect(() => {
    if (baselOrRotterdam === "rotterdam") {
      setappConvention(<RotterdamForm />)
    } else if (baselOrRotterdam === "basel") {
      setappConvention(<BaselForm />)
    } else {
      setappConvention(<div></div>)
    }
  }, [baselOrRotterdam])

  const fetchCompanies = () => {
    generalService.getCompanies().then(response => {
      console.log(response)
      if (response.status) {
        const comps = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setcompanies(comps)
      }
    })
  }
  return (
    <div>
      <Row>
        <AvField
          type="select"
          name="application_type"
          label="Select Application Type"
          required
          onChange={e => {
            toggleAppType(e.target.value)
          }}
          value={appType}
        >
          <option value="">--select--</option>
          <option value="company">Company</option>
          <option value="individual">Individual</option>
        </AvField>
      </Row>

      {appType === "company" ? (
        <>
          <br></br>
          <Row>
            <AvField
              type="select"
              name="company_id"
              label="Select Company"
              required
              value={companyId}
            >
              <option>--Select Company</option>
              {companies}
            </AvField>
          </Row>
        </>
      ) : null}

      <br></br>
      {props.editMode? <AvField type="hidden" name="convention" value={editConvention} />  : (
        <Row>
          <AvField
            type="select"
            name="convention"
            onChange={e => toggleBaselOrRotterdam(e.target.value)}
            label="Select Convention"
            required
          >
            <option>--Select Convention--</option>
            <option value="rotterdam">Rotterdam Convention</option>
            <option value="basel">Basel Convention</option>
          </AvField>
        </Row>
      )}

      <br></br>

      {appConvention}
    </div>
  )
}

export default ApplicationDetails
